"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../surface/constants");
const PREFIX_MARGIN = 5;
exports.default = theme => ({
    root: {
        height: 32,
        borderRadius: 3,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'hidden',
        boxSizing: 'border-box',
        borderWidth: 1,
        borderStyle: 'solid',
        appearance: 'none',
        flexShrink: 0,
        cursor: 'default',
        outline: 'none',
        paddingLeft: 15,
        paddingRight: 15,
        transition: `box-shadow 150ms linear, background-color 150ms linear, border-color 150ms linear`,
        color: theme.grey3,
        borderColor: 'currentColor',
        backgroundColor: 'transparent',
        '&:not([disabled]):hover, &:not([disabled]):focus': {
            color: theme.grey1,
            cursor: 'pointer'
        },
        '&[data-is-primary="true"]': {
            color: theme.white1,
            borderColor: theme.indigo3,
            backgroundColor: theme.indigo3,
            '&:not([disabled]):hover, &:not([disabled]):focus': {
                color: theme.white1,
                backgroundColor: theme.indigo2,
                borderColor: theme.indigo2,
                boxShadow: theme.indigoShadow2
            }
        },
        '&[data-is-secondary="true"]': {
            color: theme.indigo3,
            '&:not([disabled]):hover, &:not([disabled]):focus': {
                color: theme.indigo2
            }
        },
        '&[data-is-warning="true"]': {
            color: theme.warningRed,
            borderColor: theme.warningRed,
            '&:not([disabled]):hover, &:not([disabled]):focus': {
                backgroundColor: theme.warningRed,
                color: theme.white1,
                boxShadow: theme.redShadow1
            }
        },
        '&[data-is-complete=true]': {
            backgroundColor: theme.indigo3,
            color: theme.white1
        }
    },
    prefix: {
        marginRight: PREFIX_MARGIN,
        flexShrink: 0
    },
    suffix: {
        marginLeft: PREFIX_MARGIN,
        flexShrink: 0
    },
    text: {
        color: 'currentColor',
        lineHeight: `${constants_1.MIN_TARGET_SIZE - 2}px`,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 1,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
    }
});
//# sourceMappingURL=pushbutton.js.map